export default __webpack_public_path__ + "static/media/card-image11.7a03e77f.png";